enum EstimatedDateOfConfinementMethod {
    DateOfLastMenstruation,
    ClinicDate,
    Ultrasound20WeeksDate,
    OtherUltrasound
}

export { EstimatedDateOfConfinementMethod };
